import React, { useContext } from 'react'
import { ProjectContext } from '../../../context/ProjectContext'
import { ParticipantNameMenu } from './participantNameMenu'
import PropTypes from 'prop-types'
import Tippy from '@tippyjs/react'
import { AssignParticipant } from './assignParticipant'

export function TranscriptSegment({ transcript }) {
  const { participants, handleChooseParticipant } = useContext(ProjectContext)

  return (
    <div key={transcript.id} className="mt-[12px] pb-[14px] border-b border-b-[#e4e4e4]">
      {!transcript.participant_id ? (
        <div className="relative mb-[7px] flex items-center justify-between mr-[40px]">
          <AssignParticipant
            handleChooseExistingParticipant={(participantId) =>
              handleChooseParticipant(transcript.id, participantId, '')
            }
            handleChooseNewParticipant={(participantName) =>
              handleChooseParticipant(transcript.id, '', participantName)
            }
          />
          <p className="text-[#62708d] text-[13px] font-normal font-['Manrope'] leading-none">{transcript.time}</p>
        </div>
      ) : (
        <div
          className={`relative mb-[7px] flex items-center justify-between ${participants[transcript.participant_id]?.role === 'facilitator' ? 'ml-auto w-3/4' : 'mr-[40px]'}`}
        >
          <ParticipantNameMenu
            participant={participants[transcript.participant_id]}
            participantId={transcript.participant_id}
          />
          <p className="text-[#62708d] text-[13px] font-normal font-['Manrope'] leading-none">{transcript.time}</p>
        </div>
      )}

      <div
        className={`p-[10px] rounded-[5px] ${transcript.participant_id && participants[transcript.participant_id]?.role === 'facilitator' ? 'ml-auto w-3/4 bg-black text-white' : 'mr-[40px] bg-white text-[#3f424a]'}`}
      >
        {transcript.sentences.map((sentence) => (
          <div key={sentence.text}>
            {sentence.highlight ? (
              <Tippy interactive={true} placement="top" maxWidth={350} content={sentence.highlight.tooltip}>
                <p
                  className="text-[13px] font-medium font-['Manrope']"
                  style={{ backgroundColor: sentence.highlight.color, display: 'inline', lineHeight: 1.2 }}
                >
                  {sentence.text}
                </p>
              </Tippy>
            ) : (
              <p className="text-[13px] font-medium font-['Manrope'] leading-none">{sentence.text}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

TranscriptSegment.propTypes = {
  transcript: PropTypes.object,
}
